import React, { useRef, useEffect, useState } from 'react';
import { translate } from "../Services/translation";

const FacetedSearchCompact = ({ facetFilters, visibleDropdownMenu, toggleVisibleDropdownMenu, onFacetChange }) => {
    const listRefs = useRef({});
    const [scrollPosition, setScrollPosition] = useState({});

    const saveScrollPosition = (groupId) => {
        if (listRefs.current[groupId]) {
            setScrollPosition((prevState) => ({
                ...prevState,
                [groupId]: listRefs.current[groupId].scrollTop
            }));
        }
    };

    const restoreScrollPosition = (groupId) => {
        if (listRefs.current[groupId] && scrollPosition[groupId] !== undefined) {
            listRefs.current[groupId].scrollTop = scrollPosition[groupId];
        }
    };

    useEffect(() => {
        facetFilters.forEach((group) => {
            if (visibleDropdownMenu.includes(group.id)) {
                restoreScrollPosition(group.id);
            }
        });
    }, [facetFilters, visibleDropdownMenu]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (!event.target.closest('.faceted-search__group-header') && !event.target.closest('.faceted-search__sublist')) {
                toggleVisibleDropdownMenu("");
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [toggleVisibleDropdownMenu]);

    useEffect(() => {
        if (visibleDropdownMenu.length > 0) {
            document.body.classList.add('no-scroll-filters');
        } else {
            document.body.classList.remove('no-scroll-filters');
        }

        return () => {
            document.body.classList.remove('no-scroll-filters');
        };
    }, [visibleDropdownMenu]);

    return (
        <ul className="faceted-search faceted-search--compact row">
            {facetFilters.length > 0 && (
                <p className='faceted-search__description'>{translate('filter.description')}</p>
            )}
            <div className='faceted-search__group-wrapper'>
                {facetFilters && facetFilters.map((group, groupIndex) => group.options && group.options.length > 0 && (
                    <li className="columns faceted-search__group" key={`${group.label}-${groupIndex}`}>
                        <div
                            id={`faceted-search-group-${group.id}`}
                            className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id) ? 'faceted-search__group-header--show-compact' : ''}`}
                            role="faceted-search-item-group"
                            onClick={() => toggleVisibleDropdownMenu(group)}
                        >
                            {group.label}
                        </div>
                        <ul className="faceted-search__sublist">
                            <li className="faceted-search__top-row">
                                <button className="close-button" onClick={() => toggleVisibleDropdownMenu(group)}></button>
                                <p>{group.label}</p>
                            </li>
                            <li
                                ref={(el) => listRefs.current[group.id] = el} 
                                className="faceted-search__filter-list"
                                onScroll={() => saveScrollPosition(group.id)} 
                            >
                                {group.options && group.options.map((item, itemIndex) => (
                                    <div key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item">
                                        <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange} />
                                    </div>
                                ))}
                            </li>
                            <li className="faceted-search__item">
                                <button className="button filter__button" onClick={() => toggleVisibleDropdownMenu(group)}>
                                    {translate('general.close')}
                                </button>
                            </li>
                        </ul>
                    </li>
                ))}
            </div>
        </ul>
    );
};

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => (
    <label className={`faceted-filter ${item.quantity === 0 ? 'disabled' : ''}`}>
        <input className="faceted-filter__input" 
        type="checkbox" 
        onChange={() => {
            if (item.quantity === 0) return; 
            onFacetChange(group, item);
        }} 
        checked={group.selectedOptions.includes(item.id)}
        disabled={item.quantity === 0}  />
        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) && (
                <span className="faceted-filter__quantity">
                    {' '}
                    ({item.quantity})
                </span>
            )}
        </span> 
    </label>
);

export default FacetedSearchCompact;
